import AllResults from './all-results';

export default AllResults;
